module.exports = __webpack_public_path__ + "media/images/athletes/4159-b5716f398a7264ad317cd1eba77196cb.png";